import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { apiFetch } from "../../api.js";

const GRID_API = "//144.143.142.29:5000/api/designationgrid";
const DESIGNATION_API = "//144.143.142.29:5000/api/designations";

const DesignationGrid = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchData = async () => {
    try {
      const res = await apiFetch(GRID_API);
      const data = await res.json();
      setRows(data);
      setFilteredRows(data);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    if (!id) return alert("Invalid record ID");
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      const res = await apiFetch(DESIGNATION_API, {
        method: "POST",
        body: JSON.stringify({ what: "delete", sp_42: id }),
      });
      const data = await res.json();
      if (data.success) {
        alert(data.message || "Deleted successfully");
        fetchData();
      } else {
        alert(data.message || "Delete failed");
      }
    } catch (err) {
      console.error("Error deleting record:", err);
      alert("Server error while deleting");
    }
  };

  const handleEdit = (row) => {
    if (!row || !row.unqid) return alert("Invalid record data");
    navigate("/designation-form", { state: { editData: row } });
  };

  const handleSearch = async () => {
    try {
      const res = await fetch(DESIGNATION_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          what: "search",
          sp_47: searchTerm,
          sp_48: searchTerm,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setFilteredRows(data.data);
        setCurrentPage(1);
      } else {
        alert(data.message || "Search failed");
      }
    } catch (err) {
      console.error("Search error:", err);
      alert("Server error while searching");
    }
  };

  const totalPages = Math.ceil(filteredRows.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedRows = filteredRows.slice(startIndex, startIndex + pageSize);

  /*------------------- Styles--------------*/
  const pageContainerStyle = {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#f4f6f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "10px",
    boxSizing: "border-box",
  };
  const containerStyle = {
    width: "100%",
    maxWidth: "1200px",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    boxSizing: "border-box",
  };
  const headerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
    gap: "10px",
  };
  const leftHeaderStyle = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "8px",
    flex: 1,
    minWidth: "250px",
  };
  const titleStyle = {
    fontSize: "1.2rem",
    fontWeight: "bold",
    flexShrink: 0,
  };
  const addButtonStyle = {
    padding: "8px 16px",
    backgroundColor: "#3a28a0ff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  };
  const searchInputStyle = {
    flex: "1",
    minWidth: "140px",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  };
  const searchButtonStyle = {
    padding: "8px 12px",
    backgroundColor: "#2196F3",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  };
  const selectStyle = {
    padding: "8px 10px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
    whiteSpace: "nowrap",
  };
  const tableWrapperStyle = { overflowX: "auto" };
  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "400px",
  };
  const thStyle = {
    padding: "10px",
    textAlign: "left",
    backgroundColor: "#8B1E3F",
    color: "#fff",
    border: "1px solid #ddd",
    whiteSpace: "nowrap",
    fontSize: "0.9rem",
  };
  const tdStyle = {
    padding: "8px",
    border: "1px solid #ddd",
    wordWrap: "break-word",
    fontSize: "0.85rem",
  };
  const actionButtonStyle = (bgColor) => ({
    padding: "6px 10px",
    marginRight: "5px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    minWidth: "60px",
    fontSize: "0.8rem",
  });
  const paginationStyle = {
    marginTop: "12px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    fontSize: "0.9rem",
  };
  const pageBtnStyle = {
    padding: "6px 12px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    cursor: "pointer",
    background: "#f9f9f9",
    fontSize: "0.85rem",
  };

  return (
    <Layout>
      <div style={pageContainerStyle}>
        <div style={containerStyle}>
          <div style={headerStyle}>
            <div style={leftHeaderStyle}>
              <div style={titleStyle}>Designation List</div>
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={searchInputStyle}
              />
              <button style={searchButtonStyle} onClick={handleSearch}>
                Search
              </button>
              {/* Dropdown for page size (10,20,...1000) */}
              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={selectStyle}
              >
                {[...Array(100)].map((_, i) => {
                  const value = (i + 1) * 10;
                  return (
                    <option key={value} value={value}>
                      {value} / page
                    </option>
                  );
                })}
              </select>
            </div>
            <button
              style={addButtonStyle}
              onClick={() => navigate("/designation-form")}
            >
              Add New
            </button>
          </div>

          <div style={tableWrapperStyle}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Code</th>
                  <th style={thStyle}>Designation</th>
                  <th style={thStyle}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginatedRows.length === 0 ? (
                  <tr>
                    <td style={tdStyle} colSpan="3">
                      No Records
                    </td>
                  </tr>
                ) : (
                  paginatedRows.map((row) => (
                    <tr key={row.unqid}>
                      <td style={tdStyle}>{row.code}</td>
                      <td style={tdStyle}>{row.designation}</td>
                      <td style={tdStyle}>
                        <button
                          style={actionButtonStyle("#2196F3")}
                          onClick={() => handleEdit(row)}
                        >
                          Edit
                        </button>
                        <button
                          style={actionButtonStyle("#ab2025")}
                          onClick={() => handleDelete(row.unqid)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination controls */}
          <div style={paginationStyle}>
            <button
              style={pageBtnStyle}
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Prev
            </button>
            <span>
              Page {currentPage} of {totalPages || 1}
            </span>
            <button
              style={pageBtnStyle}
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DesignationGrid;
